var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"register-page"}},[_c('RegisterHero'),_c('Rules')],1)}
var staticRenderFns = []

export { render, staticRenderFns }